import { __rest } from "tslib";
import React from "react";
export var CustomRenderAsLinkMock = function CustomRenderAsLinkMock(r) {
  var t = r.href,
      e = r.children,
      c = __rest(r, ["href", "children"]);

  return React.createElement("a", Object.assign({}, c, {
    href: t
  }), e);
};
export var concatUrl = function concatUrl(r, t) {
  return t ? new URL(r, t).href : r;
};
export var addRootToCards = function addRootToCards(r, t) {
  return r.map(function (r) {
    return r.card ? Object.assign(Object.assign({}, r), {
      card: Object.assign(Object.assign({}, r.card), {
        url: concatUrl(r.card.url, t)
      })
    }) : r;
  });
};
export var addRootToTelehealthLinks = function addRootToTelehealthLinks(r, t) {
  return r.map(function (r) {
    return Object.assign(Object.assign({}, r), {
      url: concatUrl(r.url, t)
    });
  });
};
export var getUniqueProductLinks = function getUniqueProductLinks(r) {
  var t = new Set(),
      e = function e(r) {
    r.forEach(function (r) {
      return t.add(r);
    });
  };

  return r.forEach(function (r) {
    var t = r.productLinks;
    if (Array.isArray(t)) e(t);else for (var _r in t) {
      e(t[_r]);
    }
  }), Array.from(t);
};